import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChartType, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { KeycloakService } from 'keycloak-angular';
import { KpiDialogComponent } from '../../kpi-dialog/kpi-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-city-formative-evaluation',
  templateUrl: './city-formative-evaluation.component.html',
  styleUrls: ['./city-formative-evaluation.component.scss']
})
export class CityFormativeEvaluationComponent implements OnInit {

  public city = history.state.city;
  public country = history.state.country;
  public allowed: boolean = false;
  public cities = [];

  //Chart properties setup
  barChartType: ChartType = 'bar';
  barChartLabels: Label[] = ["Baseline", "M24", "M36", "M42"];
  barChartOptions: ChartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 100
        }
      }]
    },
    legend: {
      display: true,
      position: 'top'
    },
  }
  public chartColors: any[] = [{
    backgroundColor: ["#3498DB", "#3498DB", "#3498DB", "#3498DB"],
    hoverBackgroundColor: ["#85C1E9", "#85C1E9", "#85C1E9", "#85C1E9"]
  },
  {
    backgroundColor: ["#E74C3C", "#E74C3C", "#E74C3C", "#E74C3C"],
    hoverBackgroundColor: ["#F1948A", "#F1948A", "#F1948A", "#F1948A"]
  }]

  totalData: any[] = [];
  totalBaseline: number = 0;
  totalM24: number = 0;
  totalM36: number = 0;
  totalM42: number = 0;
  public total: any = [];
  public info: any = '';
  barChartData: any[] = [];

  constructor(private router: Router, private req: HttpRequestsService<any>, private keycloak: KeycloakService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.req.getCities().subscribe((res) => {
      this.cities = res;
      let cityData = [];
      let totalData = [0, 0, 0, 0];

      res.forEach(element => {
        if (element.City === this.city) {
          cityData = [element.Baseline_score, element.M24_score, element.M36_score, element.M42_score];
          this.info = element.Info;
        }
        totalData[0] += Number(element.Baseline_score);
        totalData[1] += Number(element.M24_score);
        totalData[2] += Number(element.M36_score);
        totalData[3] += Number(element.M42_score);
      })
      for (let i = 0; i < this.cities.length; i++) {
        this.totalBaseline += Number(this.cities[i].Baseline_score)
      }
      
      for (let i = 0; i < this.cities.length; i++) {
        this.totalM24 += Number(this.cities[i].M24_score)
      }
      for (let i = 0; i < this.cities.length; i++) {
        this.totalM36 += Number(this.cities[i].M36_score)
      }
      for (let i = 0; i < this.cities.length; i++) {
        this.totalM42 += Number(this.cities[i].M42_score)
      }

      this.totalBaseline = (Math.round((this.totalBaseline / 11) * 10) / 10) || 0;  //round to 1 decimal or conver to 0 if NaN
      this.totalM24 = (Math.round((this.totalM24 / 11) * 10) / 10) || 0;
      this.totalM36 = (Math.round((this.totalM36 / 11) * 10) / 10) || 0;
      this.totalM42 = (Math.round((this.totalM42 / 11) * 10) / 10) || 0;

      this.totalData = [this.totalBaseline, this.totalM24, this.totalM36, this.totalM42]

      const dataset = [
        {
          data: cityData,
          label: `${this.city} Data`,
          backgroundColor: "#3498DB",
          hoverBackgroundColor: "#85C1E9"
        },
        {
          data: this.totalData,
          label: 'Project Results',
          backgroundColor: "#E74C3C",
          hoverBackgroundColor: "#F1948A"
        }
      ]
      this.barChartData = [{
        barchartDataObject: dataset,
        barChartOptions: this.barChartOptions,
      }];

    });

    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          };
        });
      } else {
        this.allowed = false;
      }
    }
  }

  onBaseline() {
    this.router.navigateByUrl(`${this.city}/Baseline`, { state: { city: this.city, country: this.country } });
  }

  onM24() {
    this.router.navigateByUrl(`${this.city}/M24`, { state: { city: this.city, step: 'M24' } });
  }

  onM36() {
    this.router.navigateByUrl(`${this.city}/M36`, { state: { city: this.city, step: 'M36' } });
  }

  onM42() {
    this.router.navigateByUrl(`${this.city}/M42`, { state: { city: this.city, step: 'M42' } });
  }

  onInfo() {
    const replacementMap: { [key: string]: string } = {
      'question1': 'About Living Labs',
      'question2': 'About the actions',
      'question3': 'Governance - GIA’s',
      'question4': 'Consumption - CIAs',
      'question5': 'Production - PIAs',
      'question6': 'Distribution - DIAs',
      'question7': 'Waste - WIAs',
      'question8': 'About the learning tools DLA & RISA',
      'question9': 'About general learning process'
    };

    let modifiedInfo = this.info;

    for (const [key, value] of Object.entries(replacementMap)) {
      const regex = new RegExp(key, 'g');
      modifiedInfo = modifiedInfo.replace(regex, value);
    }

    this.dialog.open(KpiDialogComponent, { autoFocus: false, disableClose: false, data: { info: modifiedInfo } });
  }
}